import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ApplicationService } from '@app/applications/application.service';
import FileSaver from 'file-saver';

@Component({
    selector: 'app-db-viewer',
    templateUrl: 'db-viewer.component.html',
    styleUrls: ['../data-source.component.scss']
})
export class DbDirectComponent implements OnInit {

    queryResultData: any[] = [];
    sqlQuery: any;

    constructor(
        private applicationService: ApplicationService,
        private _snackbar: MatSnackBar) { }

    ngOnInit() {
    }

    dbDirect(){
        if(this.sqlQuery == null || this.sqlQuery == ''){
            this._snackbar.open("SQL query is required.", "close",{
                duration: 6000
            })
            return;
          }
            this.applicationService.getDbDirect(this.sqlQuery)
            .subscribe((response) => {
                this.queryResultData.push(response.body);
                // Scroll to the last item after the data is loaded from the server.
                // A timeout is added to ensure response data is updated before scrolling.
                setTimeout(() => {
                  let lastItem = document.querySelector('#scrollableContent > div:last-child');
                  if (lastItem) {
                    (lastItem as HTMLElement).scrollIntoView({ behavior: 'smooth' });
                  }
                });
        })
    }

    clearData() {
        this.sqlQuery = '';
        this.queryResultData = [];
      }

      copyToClipboard() {
        let fullText = this.queryResultData.map(resultData => `${resultData.sqlQuery}\n\n${resultData.queryResult}`)
        .join('\n\n---\n\n'); 
      
        (navigator as any).clipboard.writeText(fullText).then(() => {
          this._snackbar.open("All results copied to clipboard.", "close", {
            duration: 5000
          });
        })
    }

    downloadAsTextFile() {
      let fullText = this.queryResultData.map(resultData => 
        `${resultData.sqlQuery}\n\n${resultData.queryResult}`
      ).join('\n\n---\n\n');
    
      const blob = new Blob([fullText], { type: 'text/plain' });
      FileSaver.saveAs(blob, 'query-results.txt');
    
      this._snackbar.open("File downloaded.", "close", {
        duration: 5000
      });
    }

    removeQueryResult(index: number): void {
      this.queryResultData.splice(index, 1);
    }


    ngOnDestroy(): void {
    }

}
